import React from 'react'
import Header from '../../Component/Header';
import Footer from '../../Component/Footer';
import AccountSidebar from '../../Component/AccountSidebar';
import * as Utility from "../../js/utility";
class DepositLimit extends React.Component {
    componentDidMount() {
        
    }
    render() {
        var content = (
            <div>
                <div className="my-account">

                    <div className="container">

                        <AccountSidebar />
                        <div className="account-right-container">


                            <div className="transaction">

                                <div className="acount-inner">
                                    <h3>Add or Alter a Deposit Limit</h3>
                                </div>


                                <div style={{padding: '8px 6px', background: '#eeeeee'}}>
                                    <iframe height="485"
                                        allowtransparency="true"
                                        frameBorder="0"
                                        scrolling="no"
                                        className="withdrawIframe"
                                        src="https://geoffbanks.wufoo.com/forms/?formname=wya0sk71htewmh&embed=1&embedKey=wya0sk71htewmh403530&entsource=&referrer=http:wuslashwuslashv0.geoff-banks.comwuslashdepositlimit.asp#public" >
                                        <a href="https://geoffbanks.wufoo.com/forms/?formname=wya0sk71htewmh&embed=1&embedKey=wya0sk71htewmh403530&entsource=&referrer=http:wuslashwuslashv0.geoff-banks.comwuslashdepositlimit.asp#public">
                                        </a>
                                    </iframe >
                                </div>








                            </div>




                        </div>

                    </div>
                </div>

                <Footer />
            </div>

        );
        return (
            <div>
                {content}
            </div>

        )
    }
}


export default DepositLimit;